import { cn } from '../../lib/stylingUtils';
import { ThemeColor } from '../../types/theme';

type DashboardCardProps = {
  title: string;
  value: string;
  color?: ThemeColor;
};

const colorClasses: Partial<Record<ThemeColor, string>> = {
  primary: 'border-primary/20 bg-primary/5',
  success: 'border-success/20 bg-success/5',
  warning: 'border-warning/20 bg-warning/5',
  failure: 'border-failure/20 bg-failure/5',
};

const valueColorClasses: Partial<Record<ThemeColor, string>> = {
  primary: 'text-primary',
  success: 'text-success',
  warning: 'text-warning',
  failure: 'text-failure',
};

export const DashboardCard = ({ title, value, color }: DashboardCardProps) => (
  <div
    className={cn(
      '@DashboardCard',
      'rounded-lg border p-4',
      color && colorClasses[color],
      !color && 'border-neutral/10',
    )}
  >
    <p className="text-sm text-neutral/70">{title}</p>
    <p
      className={cn(
        'mt-1 text-2xl font-semibold',
        color && valueColorClasses[color],
      )}
    >
      {value}
    </p>
  </div>
);
